import {BaseService} from './baseService.js';

/**
 * Admin Email History API
 */
export class EmailHistoryService extends BaseService {
	
	constructor() {	
		super();
	}
	
	async getEmailHistory(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}	
		var data = await this.makeGETRequest('/api/resource/email-history' + params);		
		return data;
	}

	async getEmailHistoryRecord(emailHistoryId) {
		return await this.makeGETRequest('/api/resource/email-history/' + emailHistoryId);
	}

	async getEmailMessage(emailHistoryId) {
		return await this.makeGETRequest('/api/resource/email-history/' + emailHistoryId + '/message');
	}

	downloadEmailPackage(emailHistoryId) {
		this.downloadFile('/api/resource/email-history/' + emailHistoryId + '/download');
	}

	exportEmailHistory(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/email-history/export' + params);
	}
	
}
